import React from 'react';
import { useSelector } from 'react-redux';
import { ToolInfo } from 'components';
import { GoalDetails } from 'fragments';
import { renderGoalTypes, useModal } from 'utils';
import { SessionTargetGridCard } from './sessionCards';

/**
 * Title row of one pinned goal: the goal name as a link that opens the same `GoalDetails` modal the
 * unpinned goal rows open, and the info icon (name + data type on hover). Shared by the live and the
 * manual pinned strips.
 */
export const PinnedGoalHeader = ({ goal, clientId, requestParams }) => {
    const { open } = useModal();

    return (
        <div className="pinned-goal-header">
            <button
                type="button"
                className="goal-link-btn pinned-goal-link-btn"
                onClick={() => open(<GoalDetails goalId={goal?.id} requestParams={requestParams} clientId={clientId} viewOnly />)}
            >
                {goal?.name}
            </button>
            <ToolInfo
                text={
                    <div className="space-between" style={{ gap: 12 }}>
                        <p>{goal?.name}</p>
                        <div className="correct-goal-box">{renderGoalTypes(goal?.dataType)}</div>
                    </div>
                }
            />
        </div>
    );
};

export const SessionPinnedTargets = ({}) => {
    const sessionById = useSelector((state) => state.session.sessionById);
    const pinnedGoals = sessionById?.goals?.filter((i) => i?.pinned) || [];

    return (
        <div>
            {!!pinnedGoals?.length && (
                <div style={{ margin: '12px 0' }}>
                    <div className="goal-selector-wrapper widget-cards-box">
                        {pinnedGoals?.map((item, index) => (
                            <div key={index} className="pinned-goals-box">
                                {!!item?.goal?.targets?.length && (
                                    <PinnedGoalHeader
                                        goal={item?.goal}
                                        requestParams={{ clientId: sessionById?.appt?.client?.id }}
                                        clientId={sessionById?.appt?.client?.id}
                                    />
                                )}
                                <div className="pinned-goal-targets">
                                    {item?.goal?.targets?.map((i, j) => (
                                        <div key={j}>
                                            <SessionTargetGridCard item={i} goal={item?.goal} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
